document.addEventListener('DOMContentLoaded', function () {
    initAnswerOptionClickHandlers()
    initResultsVisibility()
})

function redirectToNextQuestion(event) {
    event.preventDefault()
    const answerOptionsElement = event.target.closest('.js-answer-options')
    let questionId = 'null'
    if (answerOptionsElement) {
        questionId = answerOptionsElement.getAttribute('data-question-id')
    }
    let questionUrl = `${event.target.getAttribute('href')}?question-${questionId}=${event.target.getAttribute(
        'data-answer-id'
    )}`

    const existingQueryParams = new URLSearchParams(window.location.search).toString()
    if (existingQueryParams) {
        questionUrl += `&${existingQueryParams}`
    }
    window.location.href = questionUrl
}

function initAnswerOptionClickHandlers() {
    const answerOptions = document.querySelectorAll('.js-answer-option') || []
    answerOptions.forEach((answerOption) => {
        answerOption.addEventListener('click', redirectToNextQuestion)
    })
}

function initResultsVisibility() {
    const results = document.querySelectorAll('.js-coach-result') || []
    const queryParams = new URLSearchParams(window.location.search)

    results.forEach((result) => {
        const matchingAnswerId =
            queryParams.get(`question-${result.getAttribute('data-question-id')}`) ===
            result.getAttribute('data-answer-id')

        if (matchingAnswerId) {
            result.classList.remove('hidden')
        }
    })
}
